import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AfterSchool = () => {
  const docs = [
    {
      title: 'MOSAIC Beacon Team Headshots',
      description: 'Meet the MOSAIC Beacon leadership team working with our school community.',
      href: '/assets/documents/afterschool/MOSAIC Beacon Team Headshots 1.pdf',
      type: 'PDF'
    },
    {
      title: 'ACDP Website Info',
      description: 'Overview and contacts for the ACDP Community School partnership.',
      href: '/assets/documents/afterschool/ACDP Website Info.docx',
      type: 'DOCX'
    }
  ];

  const contacts = [
    {
      name: 'Erik Sanders',
      role: 'Program Director, MOSAIC Beacon (Catholic Charities Alianza Division)',
      email: 'Erik.Sanders@cccsny.org'
    },
    {
      name: 'Anayess Dominguez',
      role: 'Assistant Director, MOSAIC Beacon (Catholic Charities Alianza Division)',
      email: 'Anayess.Dominguez@cccsny.org'
    },
    {
      name: 'Amanda Jusino',
      role: 'Administrative Assistant, MOSAIC Beacon (Catholic Charities Alianza Division)',
      email: 'Amanda.Jusino@cccsny.org'
    },
    {
      name: 'Maxine Shoulders',
      role: 'Director of Operations (Elementary & Middle), Catholic Charities Alianza Division',
      email: 'maxine.shoulders@cccsny.org'
    }
  ];

  const acdpContacts = [
    {
      name: 'Rosa Rojas',
      role: 'ACDP Community School Director',
      email: 'Rorojas@acdp.org / Rrojas12@schools.nyc.gov'
    },
    {
      name: 'Michelle Lajara',
      role: 'ACDP Community School Assistant Director',
      email: 'Mlajara@acdp.org'
    },
    {
      name: 'Juan Gutierrez',
      role: 'ACDP Community School Extended Learning Coordinator',
      email: 'Jugutierrez@acdp.org'
    }
  ];

  return (
    <main id="main-content" className="bg-white">
      <Navbar />

      {/* Header */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Partnerships
              </span>
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                After-School <span className="font-bold">Programs</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                Expanded learning and community partnerships that support the whole child and strengthen our families.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Partner Logos Section */}
      <section className="py-12 bg-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center gap-8 lg:gap-12 flex-wrap">
            <img
              src="/assets/images/pbis/ACDP.png"
              alt="ACDP Logo"
              className="h-20 lg:h-28 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
            />
            <img
              src="/assets/images/pbis/CCCS.png"
              alt="Catholic Charities Community Services Logo"
              className="h-20 lg:h-28 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
            />
            <img
              src="/assets/images/pbis/CS.png"
              alt="Community Schools Logo"
              className="h-20 lg:h-28 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
            />
            <img
              src="/assets/images/pbis/MOSAIC.png"
              alt="MOSAIC Logo"
              className="h-20 lg:h-28 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
            />
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <div className="lg:col-span-7">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">Our Community School Model</h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Together with MOSAIC Beacon and ACDP, P.S. 11X integrates wellness, family engagement, and expanded learning time. 
                Partnerships help connect attendance, academics, health, social services, and after‑school programming—leading to stronger families and healthier communities.
              </p>
              <div className="bg-[#630503]/5 border border-[#630503]/10 rounded-xl p-6">
                <ul className="space-y-3 text-gray-800">
                  <li className="flex items-start">
                    <span className="w-2 h-2 rounded-full bg-[#630503] mt-2 mr-3"></span>
                    Wellness and integrated student supports
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 rounded-full bg-[#630503] mt-2 mr-3"></span>
                    Expanded learning time and after‑school enrichment
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 rounded-full bg-[#630503] mt-2 mr-3"></span>
                    Family engagement and community partnerships
                  </li>
                </ul>
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <h3 className="text-xl font-bold text-[#630503] mb-4">Program Documents</h3>
                <div className="space-y-4">
                  {docs.map((doc, idx) => (
                    <a key={idx} href={doc.href} className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" target="_blank" rel="noopener noreferrer">
                      <div className="flex-shrink-0 w-12 h-12 rounded-md bg-[#630503] text-white flex items-center justify-center mr-4 font-bold">
                        {doc.type}
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900">{doc.title}</div>
                        <div className="text-sm text-gray-600">{doc.description}</div>
                      </div>
                    </a>
                  ))}
                </div>
                <p className="text-xs text-gray-500 mt-3">Documents open in a new tab.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block bg-[#630503] text-white px-6 py-2 text-xs font-bold uppercase tracking-wider mb-6 shadow-lg">Our Partners</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">MOSAIC Beacon & ACDP</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
              <h3 className="text-xl font-bold text-gray-900 mb-4">MOSAIC Beacon</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Beacon programs are school‑based community centers offering comprehensive services for youth and families. Our MOSAIC Beacon team collaborates with P.S. 11X to extend learning and support beyond the school day.
              </p>
              <div className="grid grid-cols-1 gap-4">
                {contacts.map((c, i) => (
                  <div key={i} className="p-4 bg-gray-50 rounded-lg">
                    <div className="font-semibold text-gray-900">{c.name}</div>
                    <div className="text-sm text-gray-600">{c.role}</div>
                    <a href={`mailto:${c.email}`} className="text-sm text-[#630503] font-semibold">{c.email}</a>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
              <h3 className="text-xl font-bold text-gray-900 mb-4">ACDP Community School</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                ACDP links school, families, and community services to support student attendance, health, and academics. Together, we coordinate programs, screenings, and extended learning opportunities.
              </p>
              <div className="grid grid-cols-1 gap-4">
                {acdpContacts.map((c, i) => (
                  <div key={i} className="p-4 bg-gray-50 rounded-lg">
                    <div className="font-semibold text-gray-900">{c.name}</div>
                    <div className="text-sm text-gray-600">{c.role}</div>
                    <a href={`mailto:${c.email}`} className="text-sm text-[#630503] font-semibold">{c.email}</a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#4a0402] rounded-xl shadow-xl p-10 md:p-12 text-white">
            <div className="md:flex md:items-center md:justify-between">
              <div className="max-w-2xl">
                <h3 className="text-2xl md:text-3xl font-bold mb-3">Have questions about after‑school?</h3>
                <p className="text-white/90">Reach out to our partners or contact the main office. We’re here to help connect you with programs that fit your family.</p>
              </div>
              <div className="mt-6 md:mt-0">
                <a href="/calendar" className="inline-flex items-center px-8 py-4 border-2 border-white text-lg font-bold rounded-md text-white hover:bg-white hover:text-[#630503] transition-colors">View Calendar</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default AfterSchool;


